module.exports = __webpack_public_path__ + "static/Logo-0cbe086c0035579055214de9209783f6.jpg";